import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { ReferenceDataUnitsEffects } from './state/reference-data-units.effects';
import { REFERENCE_DATA_UNITS_FEATURE_KEY, reducer } from './state/reference-data-units.reducer';

@NgModule({
    declarations: [],
    imports: [
        StoreModule.forFeature(REFERENCE_DATA_UNITS_FEATURE_KEY, reducer),
        EffectsModule.forFeature([ReferenceDataUnitsEffects]),
    ],
})
export class ReferenceDataUnitsDataAccessModule {}
